import { createRef } from 'react'

const state = {
  sections: 2,
  pages: 2,
  zoom: 0.88,
  top: createRef()
}

export default state
